//# sourceMappingURL=rect.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/vector/rect.interface.js
// module id = 1198
// module chunks = 4